import {
  Camera,
  Gamepad2,
  Headphones,
  Laptop,
  Package,
  Smartphone,
  Watch,
  type LucideIcon,
} from 'lucide-react';

export function categoryNameToIcon(name: string): LucideIcon {
  const lower = name.toLowerCase();
  if (lower.includes('phone') || lower.includes('mobile')) return Smartphone;
  if (lower.includes('laptop') || lower.includes('pc')) return Laptop;
  if (lower.includes('audio') || lower.includes('headphone')) return Headphones;
  if (lower.includes('watch')) return Watch;
  if (lower.includes('camera')) return Camera;
  if (lower.includes('gam')) return Gamepad2;
  return Package;
}
